<template lang="pug">
#job-view
  .banner.bg-cover
  .container
    section
      .row
        .col-sm-9.job-title
          h2 {{job.title | multilang}}
            br
            span.small {{job.company.name | multilang}}
          span {{'JOB_POST_DATE' | wordDict}}: {{job.ctime | moment 'D MMMM YYYY'}}
          br
          span {{'JOB_CLOSE_DATE' | wordDict}}: {{job.close_date | moment 'D MMMM YYYY'}}
        .col-sm-3
          br
          button.btn.btn-apply(@click.prevent='scrollToForm()') {{'JOB_APPLY_NOW' | wordDict}}
    section#content
      .row
        .col-xs-12 {{{job.description | multilang}}}

    section#back
      .row
        .col-xs-12
          back-button(':title'="'JOB_BACK_TO_JOBS' | wordDict", 'path'='/job/all')
      .row
        .col-xs-12
          hr

    section#application
      .row
        .col-xs-12
          form#application-form.form-horizontal('@submit.prevent'="sendApplication")
            .form-group
              label.col-sm-2.control-label(for="application-name") {{'LABEL_NAME' | wordDict}}
              .col-sm-10
                input#application-name.form-control(type="text" v-model="enquiry.name" name="name" required)

            .form-group
              label.col-sm-2.control-label(for="application-email") {{'LABEL_EMAIL' | wordDict}}
              .col-sm-10
                input#application-email.form-control(type="email" v-model="enquiry.email" name="email" required )

            .form-group
              label.col-sm-2.control-label(for="application-phone") {{'LABEL_PHONE' | wordDict}}
              .col-sm-10
                input#application-phone.form-control(type="text" v-model="enquiry.phone" required)

            .form-group
              label.col-sm-2.control-label(for="application-linkedin") {{'LABEL_LINKEDIN' | wordDict}}
              .col-sm-10
                input#application-linkedin.form-control(type="text" v-model="enquiry.linkedin" required)

            .form-group
              label.col-sm-2.control-label(for="application-subject") {{'LABEL_SUBJECT' | wordDict}}
              .col-sm-10
                input#application-subject.form-control(type="text" v-model="enquiry.subject" required)

            .form-group
              label.col-sm-2.control-label(for="application-message") {{'LABEL_MESSAGE' | wordDict}}
              .col-sm-10
                textarea#application-message.form-control(v-model="enquiry.message" rows="5" required)

            .form-group
              .col-sm-10.col-sm-push-2
                .row
                  .col-sm-4
                    .col-xs-6.col-sm-12.upload-button
                      input#fileUpload(type='file', hidden, @change='fileChosen')
                      button.full-width.btn(@click.prevent='chooseFiles()')
                        span.caption {{'JOB_UPLOAD_RESUME' | wordDict}}
                    .col-xs-6.col-sm-12
                      br
                      | {{'UPLOAD_DOC_LIMIT' | wordDict}}
                  .col-sm-4.col-sm-offset-4

                    button.full-width.btn.btn-black(':disabled'="!valid")
                      span.caption {{'SEND' | wordDict}}
</template>

<script>
import BackButton from '../back-button.vue'
import axios from 'axios'

export default {
  data () {
    return {
      url: '/api/jobs',
      rows: [],
      job: {},
      valid: false,
      enquiry: {
        name: '',
        email: '',
        phone: '',
        linkedin: '',
        subject: '',
        message: '',
      },
      file: null,
    }
  },
  computed: {
    jobId: function() {
      return this.$route.params.id
    },
  },
  watch: {
    'enquiry.name'() { this.checkFormValid() },
    'enquiry.email'() { this.checkFormValid() },
    'enquiry.phone'() { this.checkFormValid() },
    'enquiry.linkedin'() { this.checkFormValid() },
    'enquiry.subject'() { this.checkFormValid() },
    'enquiry.message'() { this.checkFormValid() },
  },
  ready () {},
  created () {
    axios.get(`${this.url}/${this.jobId}`)
    .then((response) => {
      this.job = response.data
    }).catch((err) => console.log(err));
  },
  methods: {

    fileChosen(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length || !files[0])
        return
      if (files[0].size >= 5242800) { //5mb
        alert(window.wordDict.UPLOAD_DOC_EXCEEDED)
        return
      }
      this.file = files[0]
    },
    scrollToForm() {
      document.getElementById('application').scrollIntoView({behavior: 'smooth', block: 'start'});
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    sendApplication(e) {
      let promise = null
      if (this.file) {
        let fd = new FormData()
        fd.append('file', this.file)
        promise = axios.post('/api/resources/files', fd, {
          headers: {'Content-Type': 'multipart/form-data'}
        })
      } else {
        promise = Promise.resolve({})
      }
      promise.then((res) => {
        if (res && res.status < 400) {
          this.enquiry.attachment = res.data
        }
        return axios.post(`/api/jobs/${this.jobId}/application`, this.enquiry)
      }).then((res) => {
        if (res.status < 400) {
          alert(window.wordDict.APPLY_SUCCESS)
          this.enquiry = {}
          this.file = null
        } else {
          alert(window.wordDict.APPLY_FAILED)
        }
      }).catch((err) => {
        alert(window.wordDict.APPLY_FAILED)
      })
    },
    checkFormValid() {
      this.valid = _.every(this.enquiry, val => val)
    }
  },
  components: {
    BackButton
  },
}
</script>

<style lang="scss" scoped>
@import "global";
#job-view {
  .container{
    margin-top: 0;
    margin-bottom: 0;
  }
  button > span.caption {
    width: 100%;
    margin: 0;
    text-align: center;
    line-height: initial;
  }
  .job-title {
    h2 {
      font-weight: bold;
      text-transform: uppercase;
      .small {
        color: #000;
      }
    }
    @media(max-width: #{$screen-xs-max}) {
      h2 {
        font-size: 22px;
        .small {
          font-size: 18px;
        }
      }
      .col-sm-3 {
        padding: 15px 0;
      }
    }
  }
  .btn-apply {
    background-color: #387ec0;
    color: #fff;
  }

  .banner {
    background-image: url('../../images/job/Half_4_career.jpg');
    padding: 0;
    margin: 0;
    height: 200px;
    @media(max-width: #{$screen-xs-max}) {
      height: 166px;
    }
  }

  .media-left {
    padding-right: 85px;
  }

  .media-heading {
    a {
      font-size: 16px;
      color: #6a869c;
    }
  }
  .media-body {
    font-weight: bold;
    font-size: 20px;
  }
  section {
    padding-top: 30px;
    padding-bottom: 30px;
    &:last-child {
      padding-bottom: 30px;
    }
    @media(max-width: #{$screen-xs-max}) {
      padding-top: 12px;
      padding-bottom: 12px;
      &#content {
        padding-bottom: 6px;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
  .media-object {
    max-width: 110px;
  }
  #back {
    hr {
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
  #application-form{
    .full-width {
      width: 100%;
      background-color: #eee;
    }
    .btn-black {
      background-color: #000;
      color: #FFF;
      &:hover {
        color: #FFF;
      }
    }
    .upload-button {
      padding: 0;
      .btn {
        font-size: 13px;
        padding: 7px 0px;
      }
      @media(max-width: #{$screen-xs-max}) {
        padding-bottom: 10px;
      }
    }
    .form-group {
      .form-control {
        background-color: #f6f6f6;
        border: none;
        box-shadow: none;
      }
      @media(min-width: #{$screen-sm-min}) {
        margin-left: 0;
        margin-right: 0;
      }
    }
    .control-label {
      text-align: left;
      @media(min-width: #{$screen-sm-min}) {
        padding-left: 5px;
      }
    }
  }

  a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// job-detail.vue?de1ee10c